import React, { useCallback, useRef } from 'react';
import { swipeDelta } from './viewerNavigation';

export interface SwipeHandlers {
  onPointerDown: (event: React.PointerEvent) => void;
  onPointerUp: (event: React.PointerEvent) => void;
  onPointerCancel: () => void;
}

/**
 * A left or right swipe on the narrow viewer (design a6) with pointer events, no library: a swipe
 * to the left calls `onMove(1)`, to the right `onMove(-1)`. A mouse does not swipe.
 */
export function useSwipe(onMove: (delta: -1 | 1) => void): SwipeHandlers {
  const start = useRef<{ x: number; y: number } | null>(null);
  const onPointerDown = useCallback((event: React.PointerEvent) => {
    start.current = event.pointerType === 'mouse' ? null : { x: event.clientX, y: event.clientY };
  }, []);
  const onPointerUp = useCallback(
    (event: React.PointerEvent) => {
      const from = start.current;
      start.current = null;
      if (from === null) {
        return;
      }
      const delta = swipeDelta(event.clientX - from.x, event.clientY - from.y);
      if (delta !== 0) {
        onMove(delta);
      }
    },
    [onMove]
  );
  const onPointerCancel = useCallback(() => {
    start.current = null;
  }, []);
  return { onPointerDown, onPointerUp, onPointerCancel };
}
